// Permisos RBAC de Transferencias, los mismos que exige cada endpoint de transfer-note-business.
// Sin la clave, la pantalla o la acción se esconde (fail-closed).

/** Portal SK: alcance TENANT. */
export const TRANSFER_NOTE_PERMISSIONS = {
    read: 'transfer.note.read',
    issue: 'transfer.note.issue',
    speiCapture: 'transfer.note.spei.capture',
    speiRevert: 'transfer.note.spei.revert',
    receptionConfirm: 'transfer.note.reception.confirm',
    cancel: 'transfer.note.cancel',
    disputeResolve: 'transfer.note.dispute.resolve',
    noticeSend: 'transfer.note.notice.send',
    receiptUpload: 'transfer.note.receipt.upload',
    configRead: 'transfer.config.read',
} as const;

/** Portal Luga: alcance LEVEL_1 sobre la cadena de la ruta. */
export const RETAILER_TRANSFER_NOTE_PERMISSIONS = {
    read: 'transfer.retailer.note.read',
    dispute: 'transfer.retailer.note.dispute',
    speiCapture: 'transfer.retailer.note.spei.capture',
    receptionConfirm: 'transfer.retailer.note.reception.confirm',
    receiptUpload: 'transfer.retailer.note.receipt.upload',
} as const;

export interface TransferNoteAbilities {
    canIssue: boolean;
    canCaptureSpei: boolean;
    canRevertSpei: boolean;
    canConfirmReception: boolean;
    canCancel: boolean;
    canResolveDispute: boolean;
    canSendNotice: boolean;
    canUploadReceipt: boolean;
    canDispute: boolean;
    canReadConfig: boolean;
}

export function resolveSkAbilities(granted: ReadonlySet<string>): TransferNoteAbilities {
    const has = (key: string) => granted.has(key);
    const p = TRANSFER_NOTE_PERMISSIONS;
    return {
        canIssue: has(p.issue),
        canCaptureSpei: has(p.speiCapture),
        canRevertSpei: has(p.speiRevert),
        canConfirmReception: has(p.receptionConfirm),
        canCancel: has(p.cancel),
        canResolveDispute: has(p.disputeResolve),
        canSendNotice: has(p.noticeSend),
        canUploadReceipt: has(p.receiptUpload),
        canDispute: false,
        canReadConfig: has(p.configRead),
    };
}

export function resolveRetailerAbilities(granted: ReadonlySet<string>): TransferNoteAbilities {
    const has = (key: string) => granted.has(key);
    const p = RETAILER_TRANSFER_NOTE_PERMISSIONS;
    return {
        canIssue: false,
        canCaptureSpei: has(p.speiCapture),
        canRevertSpei: false,
        canConfirmReception: has(p.receptionConfirm),
        canCancel: false,
        canResolveDispute: false,
        canSendNotice: false,
        canUploadReceipt: has(p.receiptUpload),
        canDispute: has(p.dispute),
        canReadConfig: false,
    };
}
